export default "__VITE_ASSET__w4VzZprS__"